import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export const submitDraftForReview = api(async function submitDraftForReview({ projectId, scheduleId }) {
    return mutate(
        gql`
            mutation SubmitDraftForReview($projectId: String!, $scheduleId: String!) {
                submitDraftForReview(projectId: $projectId, scheduleId: $scheduleId) {
                    success
                    missingRequiredAmendsKeys
                }
            }
        `,
        { projectId, scheduleId },
        { returns: "submitDraftForReview" }
    )
})
